import TgIcon from '@/shared/assets/icons/telegramIcon.svg?react'
import { useSupportContact } from '@/entities/domain/hooks/useSupportContact'

export const SupportContact = () => {
  const { telegramUrl, displayName } = useSupportContact()

  return (
    <div className="flex justify-between md:justify-normal items-center gap-[6px]">
      <div className="flex items-center gap-[6px]">
        <TgIcon className="w-[18px] h-[18px] text-text-secondary" />
        <span className="text-text-main dark:text-text-secondary text-sm">Поддержка: </span>
      </div>
      <a href={telegramUrl} target="_blank" rel="noopener noreferrer">
        <span className="text-primary dark:text-primary-dark text-sm">{displayName}</span>
      </a>
    </div>
  )
}
